import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';



class InvoiceItems extends PureComponent {
    constructor(props) {
        super(props);
        this.renderItems = this.renderItems.bind(this);
        this.renderTimeItem = this.renderTimeItem.bind(this);
        this.renderCostItem = this.renderCostItem.bind(this);
    }

    renderItems(items) {
        return (
            <React.Fragment>
            {items.map(item => {
                switch (item['EventType']) {
                    case 'Time':
                        return this.renderTimeItem(item);
                    case 'Cost':
                        return this.renderCostItem(item);
                    case 'Charge':
                        return this.renderPaymentItem(item);
                    default:
                        return <React.Fragment />;
                }
            })}
            </React.Fragment>);
    }

    renderTimeItem(item) {
        let hourlyRate = item.hourlyRate || '';
        if (hourlyRate) {
            hourlyRate = '$' + hourlyRate;
        }

        let time = item.time || '';
        if (time) {
            time = (time / 60.0).toFixed(2);
        }

        let amount = item.amount || 0;
        if (amount) {
            amount = amount / 100.0;
        }

        return <tr><td>{item['EventDescription']}</td><td>{item['$Sender$']}</td><td align="right">{hourlyRate}</td><td align="right">{time}</td><td align="right">${amount}</td></tr>
    }

    renderCostItem(item) {
        return (
            <React.Fragment>
            {item.items.map(item_ => <tr><td>{item_.description}</td><td>{item['$Sender$']}</td><td align="right">${item_.amount || 0}</td><td align="right">{item_.qty || 1}</td><td align="right">${(item_.amount || 0) * (item_.qty || 1)}</td></tr>)}
            </React.Fragment>);
    }

    renderPaymentItem(item) {
        let description = item['EventDescription'] || '';
        if (item['invoiceId']) {
            description += ' #' + item['invoiceId'];
        }
        return <tr><td align="right">Payment <i>{description}</i>, {item['EventDate']}</td><td align="right">-${item['$AmountInvoice$'] / 100.0}</td></tr>;
    }
    
    render() {
        const {
            invoiceItems={items: [], meta: {}}
        } = this.props;

        if (!invoiceItems.items || invoiceItems.items.length == 0) {
            return '';
        }

        const timeItems = invoiceItems.items.filter(i => i['EventType'] == 'Time');
        const costItems = invoiceItems.items.filter(i => i['EventType'] == 'Cost');
        const paymentItems = invoiceItems.items.filter(i => i['EventType'] == 'Charge');

        let timeEntriesTable = '';
        if (timeItems.length > 0) {
            let timeTotal = invoiceItems.meta['timeTotal'] || '';
            if (timeTotal) {
                timeTotal = (timeTotal / 60.0).toFixed(2);
            }

            timeEntriesTable = (
                <React.Fragment>
                <h7>Time Entries</h7>
                <Table bordered condensed hover>
                    <thead>
                        <tr>
                        <td>Time Entry</td>
                        <td>Billed By</td>
                        <td align="right">Hourly Rate</td>
                        <td align="right">Hours</td>
                        <td align="right">Amount</td>
                        </tr>
                    </thead>
                    <tbody>
                    {this.renderItems(timeItems)}
                    </tbody>
                    <tfoot>
                    <tr style={{backgroundColor: "#F2F2F2"}}><td colspan={3} align="right">Time Entries Total</td><td align="right">{timeTotal}</td><td align="right">${invoiceItems.meta['timeChargeAmount'] / 100.0}</td></tr>
                    </tfoot>
                </Table>
                </React.Fragment>);
        }

        let costEntriesTable = '';
        if (costItems.length > 0) {
            costEntriesTable = (
                <React.Fragment>
                <h7>Expenses</h7>
                <Table bordered condensed hover>
                    <thead>
                        <tr>
                        <td>Expense</td>
                        <td>Billed By</td>
                        <td align="right">Price</td>
                        <td align="right">Qty</td>
                        <td align="right">Amount</td>
                        </tr>
                    </thead>
                    <tbody>
                    {this.renderItems(costItems)}
                    </tbody>
                    <tfoot>
                    <tr style={{backgroundColor: "#F2F2F2"}}><td colspan={3} align="right">Expenses Total</td><td align="right">{invoiceItems.meta['costQtyTotal']}</td><td align="right">${invoiceItems.meta['costChargeAmount'] / 100.0}</td></tr>
                    </tfoot>
                </Table>
                </React.Fragment>);
        }

        let summaryTable = '';
        if (timeEntriesTable || costEntriesTable) {
            summaryTable = (
                <React.Fragment>
                <h7>Summary</h7>
                <Table bordered condensed hover>
                    <tbody>
                    <tr><td align="right">Total</td><td align="right">${invoiceItems.meta['totalChargeAmount'] / 100.0}</td></tr>
                    {this.renderItems(paymentItems)}
                    <tr><td align="right">Balance</td><td align="right">${invoiceItems.meta['balanceChargeAmount'] / 100.0}</td></tr>
                    <tr style={{backgroundColor: "#F2F2F2"}}><td align="right">Total Outstanding</td><td align="right">${invoiceItems.meta['chargeAmount'] / 100.0}</td></tr>
                    </tbody>
                    <tfoot>
                    </tfoot>
                </Table>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
            {timeEntriesTable}
            {costEntriesTable}
            {summaryTable}
            </React.Fragment>
        );
    }
};


InvoiceItems.propTypes = {
    invoiceItems: PropTypes.object.isRequired
};

export default InvoiceItems;